import { useState } from 'react';

import { notificationSuccess } from 'app/core/toast';
import env from 'env';
import i18next from 'i18next';
import UrlUtils from 'utils/url-utils';

import { type RecoverPasswordState } from '../../models/recoverPassword.model';
import Service from '../../services/passwordRecovery.service';

export const useRecoverPassword = () => {
  const [loading, setLoading] = useState(false);

  const submitForm = async (values: RecoverPasswordState) => {
    setLoading(true);
    try {
      const api = await Service.recoverPassword(values);
      if (!api.error) {
        notificationSuccess(i18next.t('security-password-recovery.message.password-changed'));
        window.location.href = UrlUtils.urlConcat(env.appUrl, '/login').toString();
      }
    } catch (error) {
      console.error('Recover password error:', error);
    } finally {
      setLoading(false);
    }
  };

  return { loading, submitForm };
};
